import { render, staticRenderFns } from "./consultingRecords.vue?vue&type=template&id=c898ea78&scoped=true&"
import script from "./consultingRecords.vue?vue&type=script&lang=js&"
export * from "./consultingRecords.vue?vue&type=script&lang=js&"
import style0 from "./consultingRecords.vue?vue&type=style&index=0&id=c898ea78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c898ea78",
  null
  
)

export default component.exports